/**
 * Internal staff accounts excluded from every analytics/dashboard/leaderboard
 * display — an Apexia Labs support seat inside a customer tenant isn't a
 * rep, and must not show up as one. Fixed for now, not a general staff
 * roster mechanism (see salesguru-backend-tenant's identical
 * `src/config/excludedEmails.js`, which this mirrors independently since the
 * two repos share no code).
 */
const EXCLUDED_ANALYTICS_EMAILS = ['clientsuccess@apexialabs.ai'];

/** Case-insensitive; a missing/undefined email is never excluded. */
export function isExcludedAnalyticsEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return EXCLUDED_ANALYTICS_EMAILS.includes(email.trim().toLowerCase());
}
